// 案例集锦列表页与案例详情（接口案例、具名老案例）统一挂在行业成果下，用于导航高亮归属判断。
export const isShowcaseDetailPath = pathname =>
  /^\/industry-achievements\/typical-cases(\/[^/]+)?\/?$/i.test(pathname);
